import React, { createContext, useContext, useEffect, useState } from "react";
import { THEME_CONFIG } from "../../../configs/AppConfig";

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(THEME_CONFIG);

  // Load theme from localStorage on mount
  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme) {
      try {
        const parsedTheme = JSON.parse(savedTheme);
        setTheme((prevTheme) => ({ ...prevTheme, ...parsedTheme }));
      } catch (error) {
        console.error("Error parsing saved theme:", error);
      }
    }
  }, []);

  // Save theme to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem("theme", JSON.stringify(theme));
  }, [theme]);

  const updateTheme = (updates) => {
    setTheme((prevTheme) => ({ ...prevTheme, ...updates }));
  };

  const toggleCollapsedNav = (navCollapsed) => {
    updateTheme({ navCollapsed });
  };

  const changeNavType = (navType) => {
    updateTheme({ navType });
  };

  const changeSideNavTheme = (sideNavTheme) => {
    updateTheme({ sideNavTheme });
  };

  const changeLocale = (locale) => {
    updateTheme({ locale });
  };

  const changeTopNavColor = (topNavColor) => {
    updateTheme({ topNavColor });
  };

  const changeHeaderNavColor = (headerNavColor) => {
    updateTheme({ headerNavColor });
  };

  const toggleMobileNav = (mobileNav) => {
    updateTheme({ mobileNav });
  };

  const switchTheme = (currentTheme) => {
    updateTheme({ currentTheme });
  };

  const changeDirection = (direction) => {
    updateTheme({ direction });
  };

  const value = {
    ...theme,
    updateTheme,
    toggleCollapsedNav,
    changeNavType,
    changeSideNavTheme,
    changeLocale,
    changeTopNavColor,
    changeHeaderNavColor,
    toggleMobileNav,
    switchTheme,
    changeDirection,
  };

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};
